// Auto-generated mapping of all NumPy components

import NumpyRandom_BinomialDistribution from "./numpy_components/NumpyRandom_BinomialDistribution.js";
import NumpyRandom_ChiSquareDistribution from "./numpy_components/NumpyRandom_ChiSquareDistribution.js";
import NumpyRandom_DataDistribution from "./numpy_components/NumpyRandom_DataDistribution.js";
import NumpyRandom_ExponentialDistribution from "./numpy_components/NumpyRandom_ExponentialDistribution.js";
import NumpyRandom_LogisticDistribution from "./numpy_components/NumpyRandom_LogisticDistribution.js";
import NumpyRandom_MultinomialDistribution from "./numpy_components/NumpyRandom_MultinomialDistribution.js";
import NumpyRandom_NormalDistribution from "./numpy_components/NumpyRandom_NormalDistribution.js";
import Numpy_ArrayFilter from "./numpy_components/Numpy_ArrayFilter.js";
import Numpy_ArrayIndexing from "./numpy_components/Numpy_ArrayIndexing.js";
import Numpy_ArrayIterating from "./numpy_components/Numpy_ArrayIterating.js";
import Numpy_ArrayJoin from "./numpy_components/Numpy_ArrayJoin.js";
import Numpy_ArrayReshape from "./numpy_components/Numpy_ArrayReshape.js";
import Numpy_ArraySearch from "./numpy_components/Numpy_ArraySearch.js";
import Numpy_ArrayShape from "./numpy_components/Numpy_ArrayShape.js";
import Numpy_ArraySlicing from "./numpy_components/Numpy_ArraySlicing.js";
import Numpy_ArraySort from "./numpy_components/Numpy_ArraySort.js";
import Numpy_ArraySplit from "./numpy_components/Numpy_ArraySplit.js";
import Numpy_Certificate from "./numpy_components/Numpy_Certificate.js";
import Numpy_CopyVsView from "./numpy_components/Numpy_CopyVsView.js";
import Numpy_CreatingArrays from "./numpy_components/Numpy_CreatingArrays.js";
import Numpy_DataTypes from "./numpy_components/Numpy_DataTypes.js";
import Numpy_Editor from "./numpy_components/Numpy_Editor.js";
import Numpy_Exercises from "./numpy_components/Numpy_Exercises.js";
import Numpy_GettingStarted from "./numpy_components/Numpy_GettingStarted.js";
import Numpy_Home from "./numpy_components/Numpy_Home.js";
import Numpy_Intro from "./numpy_components/Numpy_Intro.js";
import Numpy_Quiz from "./numpy_components/Numpy_Quiz.js";
import Numpy_StudyPlan from "./numpy_components/Numpy_StudyPlan.js";
import Numpy_Syllabus from "./numpy_components/Numpy_Syllabus.js";
import NumpyRandom_ParetoDistribution from "./numpy_components/NumpyRandom_ParetoDistribution.js";
import NumpyRandom_PoissonDistribution from "./numpy_components/NumpyRandom_PoissonDistribution.js";
import NumpyRandom_Intro from "./numpy_components/NumpyRandom_Intro.js";
import NumpyRandom_Permutation from "./numpy_components/NumpyRandom_Permutation.js";
import NumpyRandom_RayleighDistribution from "./numpy_components/NumpyRandom_RayleighDistribution.js";
import NumpyRandom_Seaborn from "./numpy_components/NumpyRandom_Seaborn.js";
import NumpyRandom_UniformDistribution from "./numpy_components/NumpyRandom_UniformDistribution.js";
import NumpyRandom_ZipfDistribution from "./numpy_components/NumpyRandom_ZipfDistribution.js";
import NumpyUfunc_CreateFunction from "./numpy_components/NumpyUfunc_CreateFunction.js";
import NumpyUfunc_Differences from "./numpy_components/NumpyUfunc_Differences.js";
import NumpyUfunc_FindingGCD from "./numpy_components/NumpyUfunc_FindingGCD.js";
import NumpyUfunc_FindingLCM from "./numpy_components/NumpyUfunc_FindingLCM.js";
import NumpyUfunc_Hyperbolic from "./numpy_components/NumpyUfunc_Hyperbolic.js";
import NumpyUfunc_Intro from "./numpy_components/NumpyUfunc_Intro.js";
import NumpyUfunc_Logs from "./numpy_components/NumpyUfunc_Logs.js";
import NumpyUfunc_Products from "./numpy_components/NumpyUfunc_Products.js";
import NumpyUfunc_RoundingDecimals from "./numpy_components/NumpyUfunc_RoundingDecimals.js";
import NumpyUfunc_SetOperations from "./numpy_components/NumpyUfunc_SetOperations.js";
import NumpyUfunc_SimpleArithmetic from "./numpy_components/NumpyUfunc_SimpleArithmetic.js";
import NumpyUfunc_Summations from "./numpy_components/NumpyUfunc_Summations.js";
import NumpyUfunc_Trigonometric from "./numpy_components/NumpyUfunc_Trigonometric";

const AllNumpyComponents = {
  "<NumpyRandom_BinomialDistribution />": NumpyRandom_BinomialDistribution,
  "<NumpyRandom_ChiSquareDistribution />": NumpyRandom_ChiSquareDistribution,
  "<NumpyRandom_DataDistribution />": NumpyRandom_DataDistribution,
  "<NumpyRandom_ExponentialDistribution />":
    NumpyRandom_ExponentialDistribution,
  "<NumpyRandom_LogisticDistribution />": NumpyRandom_LogisticDistribution,
  "<NumpyRandom_MultinomialDistribution />":
    NumpyRandom_MultinomialDistribution,
  "<NumpyRandom_NormalDistribution />": NumpyRandom_NormalDistribution,
  "<Numpy_ArrayFilter />": Numpy_ArrayFilter,
  "<Numpy_ArrayIndexing />": Numpy_ArrayIndexing,
  "<Numpy_ArrayIterating />": Numpy_ArrayIterating,
  "<Numpy_ArrayJoin />": Numpy_ArrayJoin,
  "<Numpy_ArrayReshape />": Numpy_ArrayReshape,
  "<Numpy_ArraySearch />": Numpy_ArraySearch,
  "<Numpy_ArrayShape />": Numpy_ArrayShape,
  "<Numpy_ArraySlicing />": Numpy_ArraySlicing,
  "<Numpy_ArraySort />": Numpy_ArraySort,
  "<Numpy_ArraySplit />": Numpy_ArraySplit,
  "<Numpy_Certificate />": Numpy_Certificate,
  "<Numpy_CopyVsView />": Numpy_CopyVsView,
  "<Numpy_CreatingArrays />": Numpy_CreatingArrays,
  "<Numpy_DataTypes />": Numpy_DataTypes,
  "<Numpy_Editor />": Numpy_Editor,
  "<Numpy_Exercises />": Numpy_Exercises,
  "<Numpy_GettingStarted />": Numpy_GettingStarted,
  "<Numpy_Home />": Numpy_Home,
  "<Numpy_Intro />": Numpy_Intro,
  "<Numpy_Quiz />": Numpy_Quiz,
  "<Numpy_StudyPlan />": Numpy_StudyPlan,
  "<Numpy_Syllabus />": Numpy_Syllabus,
  "<NumpyRandom_ParetoDistribution />": NumpyRandom_ParetoDistribution,
  "<NumpyRandom_PoissonDistribution />": NumpyRandom_PoissonDistribution,
  "<NumpyRandom_Intro />": NumpyRandom_Intro,
  "<NumpyRandom_Permutation />": NumpyRandom_Permutation,
  "<NumpyRandom_RayleighDistribution />": NumpyRandom_RayleighDistribution,
  "<NumpyRandom_Seaborn />": NumpyRandom_Seaborn,
  "<NumpyRandom_UniformDistribution />": NumpyRandom_UniformDistribution,
  "<NumpyRandom_ZipfDistribution />": NumpyRandom_ZipfDistribution,
  "<NumpyUfunc_CreateFunction />": NumpyUfunc_CreateFunction,
  "<NumpyUfunc_Differences />": NumpyUfunc_Differences,
  "<NumpyUfunc_FindingGCD />": NumpyUfunc_FindingGCD,
  "<NumpyUfunc_FindingLCM />": NumpyUfunc_FindingLCM,
  "<NumpyUfunc_Hyperbolic />": NumpyUfunc_Hyperbolic,
  "<NumpyUfunc_Intro />": NumpyUfunc_Intro,
  "<NumpyUfunc_Logs />": NumpyUfunc_Logs,
  "<NumpyUfunc_Products />": NumpyUfunc_Products,
  "<NumpyUfunc_RoundingDecimals />": NumpyUfunc_RoundingDecimals,
  "<NumpyUfunc_SetOperations />": NumpyUfunc_SetOperations,
  "<NumpyUfunc_SimpleArithmetic />": NumpyUfunc_SimpleArithmetic,
  "<NumpyUfunc_Summations />": NumpyUfunc_Summations,
  "<NumpyUfunc_Trigonometric />": NumpyUfunc_Trigonometric,
};

export default AllNumpyComponents;
